import { z } from "zod";
export const UpdateFormContextAssessmentLocationRequestSchema = z.object({
    address: z.string().max(500).nullable(),
    postalCode: z.string().max(10).nullable(),
    assessmentLocationUnknown: z.boolean(),
});
//# sourceMappingURL=formcontext.js.map